<template>
    <FormLayout>
        <FormLayoutRow>
            <p
                v-html="
                    $ti(
                        'bibhandletype.description',
                        { name: `${conflictedcontestant?.Firstname} ${conflictedcontestant?.Surname}`.trim() },
                        true,
                    )
                "
            ></p>
        </FormLayoutRow>
        <HandleBibUpdates v-model="value.BibHandleType" />
    </FormLayout>
</template>
<script setup lang="ts">
import { FormLayout, FormLayoutRow } from '@/components/Form';
import { $ti } from '@/locize';
import type { ContestantBase, RaceContestantComplete, RaceContestantDetails } from '@/objects/generated';
import HandleBibUpdates from './HandleBibUpdates.vue';

const value = defineModel<RaceContestantDetails | RaceContestantComplete>({
    required: true,
});

const props = withDefaults(
    defineProps<{
        conflictedcontestant?: ContestantBase | null;
    }>(),
    {
        conflictedcontestant: null,
    },
);
</script>
